import axios from 'axios'
import useSWR from 'swr'
import APIConstants, { TRACKING_API, TRACKING_LINK, PMS_APIs, PMS_ENDPOINT } from 'src/configs/API'
import request from 'src/utils/request'
const fetcher = (url) => axios.get(url, { headers: { 'ApiKey': 'PMS' } }).then((res) => res.data)
const fetcherPost = (url, data) =>
	request
		.pmsApi({
			url,
			data,
			method: 'POST',
		})
		.then((res) => res)

export const useTrackingOrder = (id) => {
	let idList = Array.from(new Set(id.split(',').map((item) => encodeURIComponent(item.trim()))))

	// const { data, error, isValidating } = useSWR(
	// 	`${APIConstants.API_TRACKINGMULTI}` + idList,
	// 	fetcher,
	// 	{
	// 		shouldRetryOnError: false,
	// 		onErrorRetry: (error) => {
	// 			if (!error || !error.status || error.status === 403 || error.status === 404) return
	// 		},
	// 	}
	// )
	const { data, error, isValidating } = fetcher(`${APIConstants.API_TRACKINGMULTI}` + idList)

	return {
		orders: data?.orders,
		isLoading: isValidating,
		isError: error,
	}
}

// export const useTrackingOrderDetail = (id, user, phoneCode, captchaPassed) => {
// 	if (!captchaPassed) return
// 	let isDetail = id && id.split(',').length === 1

// 	let dataRequest = {
// 		OrderCode: id?.toUpperCase(),
// 		ClientID: user?.clientID,
// 		Token: user?.token,
// 		TrackingPhoneNumber: phoneCode || '',
// 	}

// 	const { data, error } = useSWR(
// 		isDetail ? [`${TRACKING_API}/Order/Tracking`, dataRequest] : null,
// 		fetcherPost,
// 		{
// 			dedupingInterval: 1000000,
// 			revalidateOnFocus: false,      // Prevent refetch on window focus
// 			revalidateIfStale: false,     // Disable revalidation when data becomes stale
// 			revalidateOnReconnect: false, // Prevent refetch on reconnect
// 			shouldRetryOnError: false,    // Disable retry on error
// 		}
// 	)
// 	return {
// 		order: data,
// 		isLoading: !error && !data,
// 		isError: error,
// 	}
// }
export const useTrackingOrderDetail = (
	id,
	user,
	phoneCode,
	captchaPassed
  ) => {
	const isDetail = !!id && id.split(',').length === 1
  
	const dataRequest = {
	  OrderCode: id?.toUpperCase(),
	  ClientID: user?.clientID,
	  Token: user?.token,
	  TrackingPhoneNumber: phoneCode || '',
	}
	
	const shouldFetch =
	  captchaPassed &&
	  isDetail;
	 
  
	const { data, error } = useSWR(
	  shouldFetch
		? [`${TRACKING_API}/Order/Tracking`, dataRequest]
		: null,
	  fetcherPost,
	  {
		dedupingInterval: 1000000,
		revalidateOnFocus: false,
		revalidateIfStale: false,
		revalidateOnReconnect: false,
		shouldRetryOnError: false,
	  }
	)
  
	return {
	  order: data,
	  isLoading: shouldFetch && !data && !error,
	  isError: error,
	}
  }
  

export const useTrackingOrderPackage = (id) => {
	let isDetail = id && id.split(',').length === 1

	const { data, error } = useSWR(
		isDetail ? `${PMS_ENDPOINT}/Tracking/GetPackages?ordercode=` + id?.toUpperCase() : null,
		fetcher,
		{
			dedupingInterval: 1000000,
			revalidateOnFocus: false,      // Prevent refetch on window focus
			revalidateIfStale: false,     // Disable revalidation when data becomes stale
			revalidateOnReconnect: false, // Prevent refetch on reconnect
			shouldRetryOnError: false,    // Disable retry on error
		}
	)

	return {
		packages: data,
		isLoading: !error && !data,
		isError: error,
	}
}

export const useTrackingHistory = (id, user, isFullInfo) => {
	let isDetail = id && id.split(',').length === 1

	let dataRequest = {
		OrderCode: id?.toUpperCase(),
	}

	const { data, error } = useSWR(
		isFullInfo && isDetail && user?.clientID
			? [`${PMS_ENDPOINT}${PMS_APIs.API_GET_CHANGE_HISTORY}`, dataRequest]
			: null,
		fetcherPost,
		{
			dedupingInterval: 3600,
		}
	)

	return {
		history: data?.data?.history,
		isLoading: !error && !data,
		isError: error,
	}
}

export const useCheckRouteOrder = (order) => {
	let idList = Array.from(new Set(id.split(',').map((item) => encodeURIComponent(item.trim()))))

	const { data, error } = useSWR(`${TRACKING_LINK}/api/Order/RouteTracking` + idList, fetcher, {
		dedupingInterval: 1200000,
	})

	return {
		orders: data?.orders,
		isLoading: !error && !data,
		isError: error,
	}
}
